import type { RequirementNode, RequirementTheme } from '@ispot/shared'

const DEFAULT_THEME_SWATCH = 'var(--color-warm-300)'

export function ThemeChips({
  node,
  themeById,
}: {
  node: RequirementNode
  themeById?: Map<string, RequirementTheme>
}) {
  if (!node.themeIds.length || !themeById) {
    return <span style={{ fontSize: 11, color: 'var(--color-warm-300)' }}>—</span>
  }
  const primaryId = node.primaryThemeId
  const sorted = [...node.themeIds].sort((a, b) => {
    if (a === primaryId) return -1
    if (b === primaryId) return 1
    return 0
  })
  return (
    <div className="flex items-center flex-wrap" style={{ gap: 4 }}>
      {sorted.map(id => {
        const theme = themeById.get(id)
        if (!theme) return null
        const isPrimary = id === primaryId
        const swatch = theme.color ?? DEFAULT_THEME_SWATCH
        return (
          <span
            key={id}
            className="inline-flex items-center gap-1"
            title={theme.description ?? theme.name}
            style={{
              fontSize: 10.5,
              fontWeight: 500,
              letterSpacing: '0.02em',
              padding: '2px 7px',
              borderRadius: 999,
              background: isPrimary ? swatch : 'transparent',
              color: isPrimary ? '#fff' : 'var(--color-text-secondary)',
              border: isPrimary ? `1px solid ${swatch}` : '1px solid var(--color-border)',
              lineHeight: 1.4,
              whiteSpace: 'nowrap',
            }}
          >
            {!isPrimary && (
              <span
                aria-hidden
                style={{ width: 6, height: 6, borderRadius: 2, background: swatch, flexShrink: 0 }}
              />
            )}
            <span className="truncate" style={{ maxWidth: 120 }}>{theme.name}</span>
          </span>
        )
      })}
    </div>
  )
}
